import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import { post } from "../../../../../actions/general";
import { editTask } from "../../../../../store/plan/actions";

import TonesetStaff from "./loadable";

export default connect(null, { editTask, post })(injectIntl(TonesetStaff as any))